<template>
  <div class="insurance_refunds wc-lg" :class="{ bg_gray: _.get(contentData, 'conf.conf[0]') }">
    <div class="insurance_refunds__wrapper container">
      <h2 class="f-24 bold insurance_refunds__ttl uppercase">
        {{ _.get(content, "title") }}
      </h2>
      <div v-if="_.get(content, 'teaser')" class="insurance_refunds__teaser" v-html="_.get(content, 'teaser')"></div>
      <div class="insurance_refunds__upper-col grid">
        <div class="insurance_refunds__row flex a_center" v-for="(tab, index) in _.get(content, 'content.tabs')"
          :key="index">
          <div class="insurance_refunds__icon" v-html="_.get(tab, 'svg')"></div>
          <h2 class="f-18 medium">{{ _.get(tab, "title") }}</h2>
        </div>
      </div>
      <div class="insurance_refunds__lower-col br-12" v-if="content_2">
        <h3 class="f-24 bold insurance_refunds__ttl uppercase">
          {{ _.get(content_2, "title") }}
        </h3>
        <div v-if="_.get(content_2, 'teaser')" class="insurance_refunds__teaser_2" v-html="_.get(content_2, 'teaser')"></div>
        <div class="insurance_refunds__lower-col--inner grid"
          :class="{ two_cols: _.size(content_2.content.tabs) == 2, one_col: _.size(content_2.content.tabs) == 1 }">
          <div class="insurance_refunds__low-row br-12" :style="{ backgroundColor: '#DEDBFA' }"
            v-for="(tab, index) in _.get(content_2, 'content.tabs')" :key="index">
            <h2 class="f-14 medium">{{ _.get(tab, "title") }}</h2>
          </div>
        </div>
        <div class="insurance_refunds__teaser_3" v-html="_.get(content_2, 'descritpion')"></div>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
export default {
  props: ["contentData"],
  mixins: [resize_handler],
  computed: {
    content() {
      let data = _.get(this.contentData, "data.list");
      data = data.filter((item) => item.type == "main");
      return data[0];
    },
    content_2() {
      let data = _.get(this.contentData, "data.list");
      data = data.filter((item) => item.type !== "main");
      return data[0];
    },
  },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.insurance_refunds__teaser_3 {
  &::v-deep {

    p,
    a,
    strong {
      color: #090909;
    }
  }
}
</style>